import { connect } from 'react-redux';
import SubscriptionPage from './SubscriptionPage';

import { subscriptionOperations } from './duck';
import { loadLocationData } from 'actions/dashboard-actions';

const mapStateToProps = ({
  locationReducer,
  appReducer,
  subscriptionReducer,
}) => {
  return {
    locationId: locationReducer.location_code,
    locationData: locationReducer.location_data,
    plans: appReducer.plans.data,
    enrollments: subscriptionReducer.enrollments.data,
  };
};

const mapDispatchToProps = (dispatch) => {

  const getPlans = (locationId) => {
    dispatch(subscriptionOperations.fetchPlans(locationId));
  };

  const refreshLocationData = () => {
    dispatch(loadLocationData());
  };

  return {
    getPlans,
    refreshLocationData,
  };
};

const SubscriptionContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SubscriptionPage);

export default SubscriptionContainer;